import { Component, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { faSave } from '@fortawesome/free-solid-svg-icons';
import { TranslatePipe } from '@ngx-translate/core';
import { ButtonComponent, DialogFooterComponent, DialogHeaderComponent } from '@akostm/orbit-ui';
import { ReactiveFormsModule } from '@angular/forms';
import { ColorPickerDirective } from 'ngx-color-picker';

export interface ColorSelection {
  headerColor?: string;
  buttonColor?: string;
  buttonHoverColor?: string;
  buttonLabelColor?: string;
  clientButtonColor?: string;
  clientButtonHoverColor?: string;
  clientButtonLabelColor?: string;
  senderChatBubbleColor?: string;
  participantChatBubbleColor?: string;
  senderChatBubbleTextColor?: string;
  participantChatBubbleTextColor?: string;
  clientSenderChatBubbleColor?: string;
  clientParticipantChatBubbleColor?: string;
  clientSenderChatBubbleTextColor?: string;
  clientParticipantChatBubbleTextColor?: string;
}

@Component({
  selector: 'lib-color-dialog',
  imports: [
    CommonModule,
    TranslatePipe,
    DialogHeaderComponent,
    ReactiveFormsModule,
    ColorPickerDirective,
    ButtonComponent,
    DialogFooterComponent,
  ],
  standalone: true,
  templateUrl: './color-dialog.component.html',
  styleUrl: './color-dialog.component.scss',
})
export class ColorDialogComponent {
  readonly #dialogRef = inject(DialogRef);
  readonly data: any = inject(DIALOG_DATA);

  closeDialog(save: boolean): void {
    if (save) {
      const headerColor = this.data.form.get('headerColor')?.value;
      const buttonColor = this.data.form.get('buttonColor')?.value;
      const buttonHoverColor = this.data.form.get('buttonHoverColor')?.value;
      const buttonLabelColor = this.data.form.get('buttonLabelColor')?.value;
      const clientButtonColor = this.data.form.get('clientButtonColor')?.value;
      const clientButtonHoverColor = this.data.form.get('clientButtonHoverColor')?.value;
      const clientButtonLabelColor = this.data.form.get('clientButtonLabelColor')?.value;
      const senderChatBubbleColor = this.data.form.get('senderChatBubbleColor')?.value;
      const participantChatBubbleColor = this.data.form.get('participantChatBubbleColor')?.value;
      const senderChatBubbleTextColor = this.data.form.get('senderChatBubbleTextColor')?.value;
      const participantChatBubbleTextColor = this.data.form.get(
        'participantChatBubbleTextColor'
      )?.value;
      const clientSenderChatBubbleColor = this.data.form.get('clientSenderChatBubbleColor')?.value;
      const clientParticipantChatBubbleColor = this.data.form.get(
        'clientParticipantChatBubbleColor'
      )?.value;
      const clientSenderChatBubbleTextColor = this.data.form.get(
        'clientSenderChatBubbleTextColor'
      )?.value;
      const clientParticipantChatBubbleTextColor = this.data.form.get(
        'clientParticipantChatBubbleTextColor'
      )?.value;

      const selectedColors: ColorSelection = {
        headerColor,
        buttonColor,
        buttonHoverColor,
        buttonLabelColor,
        clientButtonColor,
        clientButtonHoverColor,
        clientButtonLabelColor,
        senderChatBubbleColor,
        participantChatBubbleColor,
        senderChatBubbleTextColor,
        participantChatBubbleTextColor,
        clientSenderChatBubbleColor,
        clientParticipantChatBubbleColor,
        clientSenderChatBubbleTextColor,
        clientParticipantChatBubbleTextColor,
      };
      this.#dialogRef.close(selectedColors);
    } else {
      this.#dialogRef.close(false);
    }
  }
}
